<template>
    <div class="about min-contain">
        <div class="about-main">
            <div class="main-contain1 ">
                <div class="main-contain1-info"  style="color: #000">
                    <div class="title">
                        <img src="../assets/other/about3.jpg" alt="">
                        <div> 致力于为跨境电商
                            <div> 提供全球物流的专业解决方案</div>
                        </div>

                    </div>
                    <div class="text">
                        <span
                            class="big">华冠科技</span>是一家是专业从事跨境电商物流的綜合服务商,与大韩、国航、英航等知名航司保持长期战略合作伙伴关系,与国外USPS、DHL、UPS等全球优质物流商有着紧密合作。
                    </div>
                    <div class="text">
                        主要负责跨境电商空运物流服务,主营业务范围涵盖中港速运、共享智慧仓储、欧美专线小包,为多家海外电商平台提供门到门一站式解决方案。
                    </div>
                </div>

            </div>
            <div class="main-contain2">
                <img src="../assets/other/about1.jpg" alt="">
            </div>
        </div>
        <div class="about-main">
            <div class="main-contain2">
                <img src="../assets/other/about2.jpg" alt="">
            </div>
            <div class="main-contain1 blue">
                <div class="main-contain1-info">
                    <div class="title">
                        <img src="../assets/other/about4.png" alt="">
                        <div> 公司实力</div>
                    </div>
                    <div class="text">
                        <span
                            class="big">TEMU平台核心物流服务商之一,</span>华冠科技日均处理量超100万个包裹，月均货量超7000吨。
                    </div>
                    <div class="text">
                        未来，华冠科技将继续秉持“让好产品走遍全世界”的企业使命，致力成为跨境行业的领跑者，以持续技术创新，为客户不断创造价值
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: 'About',
    data() {
        return {

        }
    }
}
</script>

<style lang="less" scoped>
.about-main {
    height: 520px;
    width: 100%;
    display: flex;
    min-height: 50vh;

    .main-contain1 {
        width: 60%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .main-contain1-info {
            width: 52%;
            color: #fff;

            .title {
                font-size: 25px;
                display: flex;
                align-items: center;
                margin-bottom: 30px;

                img {
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    margin-right: 20px;
                }
            }

            .text {
                line-height: 30px;
                margin-bottom: 10px;
            }

            .big {
                font-size: 25px;
            }
        }

    }

    .blue {
        background: #00309F;
    }

    .main-contain2 {
        width: 40%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
}
</style>